import React from "react";
import { Link } from "react-router-dom";

const HeaderComponent = ({ save, loading }) => {
  return (
    <nav className="navbar fixed-top fixed-top-lg navbar-violet-md px-4">
      <Link to="/app/settings">
        <img
          src={require("assets/svgs/Cross.svg").default}
          className="cross-icon"
          alt="LeftArrow"
        />
      </Link>
      <div className="navbar-brand mr-auto pt-2">
        &nbsp; &nbsp; Monthly Stats
      </div>
    </nav>
  );
};

export default HeaderComponent;
